<div class="sentiment-actionable-card">
  <div class="sentiment-actionable-card__value">{{ count | number }}</div>
  <div class="sentiment-actionable-card__label">{{ label }}</div>
</div>
